import giftcards from '../../../assets/giftcards.png'
import posystem from '../../../assets/posystem.png'
import ecommerce from '../../../assets/ecommerce.png'
import bookingsystem from '../../../assets/bookingsystem.png'

export const projects = [
    {
      title: 'Pet Grooming CRM',
      description: 'A SaaS CRM for pet groomers with scheduling, client management, marketing, analytics, notifications, and payments.',
      technologies: ['ASP.NET Web Core API', 'Vue.js', 'MS SQL', 'Postman', 'Restful API', 'Javascript'],
      photos: [bookingsystem],
      isCarousel: true
    },
    {
      title: 'Branded Merch Shop',
      description: 'B2B platform for custom corporate merchandise and event giveaways.',
      technologies: ['ASP.NET MVC', 'EpiServer', 'MS SQL', 'Postman', 'Restful API', 'JQuery', 'Javascript'],
      photos: [ecommerce],
      isCarousel: false
    },
    {
      title: 'Gift Cards Site',
      description: 'Online store for employees to purchase corporate merchandise using gift cards.',
      technologies: ['ASP.NET MVC', 'EpiServer', 'MS SQL', 'Postman', 'Restful API', 'JQuery', 'Javascript'],
      photos: [giftcards],
      isCarousel: false
    },
    {
      title: 'Purchase Order System',
      description: "System for managing, tracking, and fulfilling purchase orders, with Microsoft SSO integration.",
      technologies: ['Vue.js', 'Ionic', 'Bootstrap', 'MS SQL'],
      photos: [posystem],
      isCarousel: true
    }
  ]